<div class="card-actuation header-actuation m-r-6" *ngIf="VisiblePanel">
  <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="h3 pr-16 cardHeader">Documento</div>
  </div>
  <div *ngIf="EmployeeFormGroup" class="inner-card m-t--7" [formGroup]="EmployeeFormGroup">
    <div class="flow-root column">
      <div class="full-width p-0" formArrayName="Document">
          <div class="uploadfilecontainer" (click)="fileInput.click()" appDragAndDrop
               (OnFileDropped)="uploadFile($event)">
              <!--<input hidden type="file" #fileInput (change)="uploadFile($event.target.files)" accept="application/pdf">-->
              <input hidden type="file" #fileInput (change)="uploadFile($event.target.files)" accept="{{FileFormatEnum.TrabajadorControllerDocumento}}">
              <input hidden type="text" formControlName="Type">
              <input hidden type="text" formControlName="File">
              <mat-error *ngIf="(EmployeeFormGroup.get(['Document','File']).dirty || EmployeeFormGroup.get(['Document','File']).touched ) && EmployeeFormGroup.get(['Document','File']).invalid">
                  <span *ngIf="EmployeeFormGroup.get(['Document','File']).errors.required" class="validation-span">Obligatorio</span>
              </mat-error>
              <mat-icon class="f-s-19 upload_icon">cloud_upload</mat-icon>
          </div>
        <div class="files-list" *ngIf="file">
          <p> {{ file }} </p>
          <button class="delete-file" (click)="deleteAttachment()">
            <mat-icon class="f-s-19">delete_forever</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>